import styled from 'styled-components'

const Wrapper = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
`

const ContentWrapper = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: left;
    padding: 30px;
    gap: 10px;
`
const PicWrapper = styled.div`
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: top;
    gap: 10px;
`
const NextButton = styled.button`
    width: 120px;
    height: 40px;
    background-color: #31c690;
    color: white;
    border: none;
    border-radius: 50px;
    font-size: 16px;
    &:hover {
        cursor: pointer;
        background-color: #28a57a;
    }
`
export default function MovingTheNextGen({
    handleGetStartedClick,
}: {
    handleGetStartedClick: (stage: 'Equipment') => void
}) {
    return (
        <Wrapper>
            <PicWrapper>
                <iframe
                    width="580"
                    height="315"
                    src="https://www.youtube.com/embed/CatmN0c99XY?si=U8IL-nAXphu547qr"
                    title="YouTube video player"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                ></iframe>
            </PicWrapper>
            <ContentWrapper>
                <h1>Move the Next Generation</h1>
                <h3>An AI automated movement skill assessment solution</h3>
                <p>
                    Moving the The Gen automatically assesses and reports on
                    children's level of proficiency across seven movement
                    skills. This data will allow you to plan and deliver
                    targeted teaching and learning programs based on the
                    students’ movement competence, evaluate the impact of your
                    teaching, and adapt your teaching to better meet the needs
                    of all students.
                </p>
                <NextButton onClick={() => handleGetStartedClick('Equipment')}>
                    Get Started
                </NextButton>
            </ContentWrapper>
        </Wrapper>
    )
}
